/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Invoke the page initializers declared by a `<div data-page="…">` marker
 * (emitted by the `<twig:RegisterPage>` component) and collect their cleanups.
 *
 * Pages load lazily via `app.loadPage()`, so setup is awaited before the
 * collected cleanups are returned.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-page]',
    async connect(element, { app }) {
        const ids = JSON.parse(element.dataset.page)
        const params = JSON.parse(element.dataset.pageParams || '{}')

        const cleanups = (await Promise.all(ids.map((id) => app.loadPage(id, params, element)))).filter(
            (cleanup) => typeof cleanup === 'function'
        )

        return () => cleanups.forEach((cleanup) => cleanup())
    },
}
